import loadable from '@loadable/component';

const CompanyListPage = loadable(() => import('./page'));
const CompanyDetailPage = loadable(() => import('./[id]/page'));
const CompanyNewPage = loadable(() => import('./new/page'));

export const routes = [
  {
    path: '',
    element: <CompanyListPage />,
  },
  {
    path: 'new',
    element: <CompanyNewPage />,
  },
  {
    path: ':id',
    element: <CompanyDetailPage />,
  },
];
